<template>
    <div>
        <div id="password-change-wrapper">
            <div class="form-title-row">
                <button
                    v-if="!isInitialPasswordChangeRequired"
                    type="button"
                    @click="goBack"
                    class="back-button"
                    aria-label="Zurück zum Login"
                >
                    <img :src="require('@/assets/dashboard/angle-left-solid-dark-grey.svg')" alt="" />
                </button>
                <h3>Passwort ändern</h3>
            </div>
            <p v-if="isInitialPasswordChangeRequired" class="required-password-change-info">
                Bitte ändern Sie Ihr Passwort, bevor Sie den Konfigurator nutzen.
            </p>
            <form
                id="password-change-form"
                @submit.prevent="changePassword"
                @invalid.capture="setFieldValidationMessage"
                @input.capture="clearFieldValidationMessage"
            >
                <div class="form-column">
                    <div class="input-container">
                        <label for="change-kdnr">Kundennummer:</label>
                        <input id="change-kdnr" v-model.trim="kdnr" type="text" required>
                    </div>
                    <div class="input-container">
                        <label for="change-email">E-Mail:</label>
                        <input id="change-email" v-model.trim="email" type="email" required>
                    </div>
                    <div class="input-container">
                        <label for="change-current-password">Aktuelles Passwort:</label>
                        <div class="password-wrapper">
                            <input id="change-current-password" v-model="currentPassword" :type="showCurrentPassword ? 'text' : 'password'" required>
                            <button type="button" class="eye-toggle" @click="showCurrentPassword = !showCurrentPassword" :aria-label="showCurrentPassword ? 'Aktuelles Passwort verbergen' : 'Aktuelles Passwort anzeigen'">
                                <svg v-if="!showCurrentPassword" width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="M1 12s4-7 11-7 11 7 11 7-4 7-11 7-11-7-11-7z"/><circle cx="12" cy="12" r="3"/></svg>
                                <svg v-else width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="M17.94 17.94A10.07 10.07 0 0 1 12 19c-7 0-11-7-11-7a18.45 18.45 0 0 1 5.06-5.94"/><path d="M9.9 4.24A9.12 9.12 0 0 1 12 4c7 0 11 7 11 7a18.5 18.5 0 0 1-2.16 2.88"/><line x1="1" y1="1" x2="23" y2="23"/><path d="M14.12 14.12A3 3 0 0 1 9.88 9.88"/></svg>
                            </button>
                        </div>
                    </div>
                    <div class="input-container">
                        <label for="change-new-password">Neues Passwort:</label>
                        <div class="password-wrapper">
                            <input id="change-new-password" v-model="newPassword" :type="showNewPassword ? 'text' : 'password'" minlength="6" required>
                            <button type="button" class="eye-toggle" @click="showNewPassword = !showNewPassword" :aria-label="showNewPassword ? 'Neues Passwort verbergen' : 'Neues Passwort anzeigen'">
                                <svg v-if="!showNewPassword" width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="M1 12s4-7 11-7 11 7 11 7-4 7-11 7-11-7-11-7z"/><circle cx="12" cy="12" r="3"/></svg>
                                <svg v-else width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="M17.94 17.94A10.07 10.07 0 0 1 12 19c-7 0-11-7-11-7a18.45 18.45 0 0 1 5.06-5.94"/><path d="M9.9 4.24A9.12 9.12 0 0 1 12 4c7 0 11 7 11 7a18.5 18.5 0 0 1-2.16 2.88"/><line x1="1" y1="1" x2="23" y2="23"/><path d="M14.12 14.12A3 3 0 0 1 9.88 9.88"/></svg>
                            </button>
                        </div>
                    </div>
                    <div class="input-container">
                        <label for="change-new-password-confirmation">Neues Passwort bestätigen:</label>
                        <div class="password-wrapper">
                            <input id="change-new-password-confirmation" v-model="newPasswordConfirmation" :type="showNewPasswordConfirmation ? 'text' : 'password'" minlength="6" required>
                            <button type="button" class="eye-toggle" @click="showNewPasswordConfirmation = !showNewPasswordConfirmation" :aria-label="showNewPasswordConfirmation ? 'Passwortbestätigung verbergen' : 'Passwortbestätigung anzeigen'">
                                <svg v-if="!showNewPasswordConfirmation" width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="M1 12s4-7 11-7 11 7 11 7-4 7-11 7-11-7-11-7z"/><circle cx="12" cy="12" r="3"/></svg>
                                <svg v-else width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="M17.94 17.94A10.07 10.07 0 0 1 12 19c-7 0-11-7-11-7a18.45 18.45 0 0 1 5.06-5.94"/><path d="M9.9 4.24A9.12 9.12 0 0 1 12 4c7 0 11 7 11 7a18.5 18.5 0 0 1-2.16 2.88"/><line x1="1" y1="1" x2="23" y2="23"/><path d="M14.12 14.12A3 3 0 0 1 9.88 9.88"/></svg>
                            </button>
                        </div>
                    </div>

                    <div v-if="errorMessage" class="error-message">{{ errorMessage }}</div>
                    <div v-if="successMessage" class="success-message">{{ successMessage }}</div>

                    <div class="actions">
                        <button :disabled="isSaving" type="submit">
                            {{ isSaving ? 'Speichern...' : 'Passwort ändern' }}
                        </button>
                    </div>
                </div>
            </form>
        </div>
    </div>
</template>

<script>
import api from "@/api/client";

export default {
    name: 'PasswordChange',
    data() {
      return {
        kdnr: "",
        email: "",
        currentPassword: "",
        newPassword: "",
        newPasswordConfirmation: "",
        showCurrentPassword: false,
        showNewPassword: false,
        showNewPasswordConfirmation: false,
        isInitialPasswordChangeRequired: false,
        isSaving: false,
        errorMessage: "",
        successMessage: "",
      }
    },
    methods: {
        goBack() {
            this.$parent.changeMenuState(0);
        },
        resetForm() {
            this.kdnr = "";
            this.email = "";
            this.currentPassword = "";
            this.newPassword = "";
            this.newPasswordConfirmation = "";
            this.showCurrentPassword = false;
            this.showNewPassword = false;
            this.showNewPasswordConfirmation = false;
            this.isInitialPasswordChangeRequired = false;
            this.isSaving = false;
            this.errorMessage = "";
            this.successMessage = "";
        },
        startInitialPasswordChange({ kdnr = "", email = "", currentPassword = "" } = {}) {
            this.resetForm();
            this.kdnr = kdnr;
            this.email = email;
            this.currentPassword = currentPassword;
            this.isInitialPasswordChangeRequired = true;
        },
        async changePassword() {
            this.errorMessage = "";
            this.successMessage = "";

            if (this.newPassword !== this.newPasswordConfirmation) {
                this.errorMessage = "Die neuen Passwörter stimmen nicht überein.";
                return;
            }

            if (this.newPassword === this.currentPassword) {
                this.errorMessage = "Das neue Passwort darf nicht dem bisherigen Passwort entsprechen.";
                return;
            }

            this.isSaving = true;
            try {
                const wasInitialPasswordChangeRequired = this.isInitialPasswordChangeRequired;
                await api.post('/api/shopusers/password/change', {
                    kdnr: this.kdnr,
                    email: this.email,
                    current_password: this.currentPassword,
                    password: this.newPassword,
                    password_confirmation: this.newPasswordConfirmation,
                });

                this.successMessage = wasInitialPasswordChangeRequired
                    ? "Ihr Passwort wurde geändert. Bitte melden Sie sich mit dem neuen Passwort an."
                    : "Ihr Passwort wurde geändert. Sie können sich jetzt einloggen.";
                this.currentPassword = "";
                this.newPassword = "";
                this.newPasswordConfirmation = "";
                this.isInitialPasswordChangeRequired = false;
                if (wasInitialPasswordChangeRequired) {
                    this.$emit('password-changed');
                }
            } catch (err) {
                this.errorMessage = err?.response?.data?.message || 'Passwort ändern fehlgeschlagen. Bitte Eingaben prüfen.';
            } finally {
                this.isSaving = false;
            }
        },
        setFieldValidationMessage(event) {
            const field = event.target;
            if (!field || typeof field.setCustomValidity !== 'function') {
                return;
            }

            field.setCustomValidity(field.validity?.valueMissing
                ? "Bitte füllen Sie dieses Feld aus"
                : "");
        },
        clearFieldValidationMessage(event) {
            const field = event.target;
            if (field && typeof field.setCustomValidity === 'function') {
                field.setCustomValidity("");
            }
        },
    },
}

</script>

<style scoped src="@/styles/FirstUserPassword.css">

</style>
